export default {
    paginate: {
        next: 'След.',
        prev: 'Пред.',
    },
}
